import { SettingCard, SettingCardRow } from '@components/Dashboard/components'
import { AngleRight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  title: string
  onClick: () => void
}

export const LeaveTeamCard: React.FC<Props> = ({ title, onClick }) => {
  return (
    <SettingCard title="Leave team">
      <SettingCardRow
        title={`Leave ${title}`}
        description=" You will be prompted to confirm your account deletion."
      >
        <button
          onClick={onClick}
          type="button"
          className={css.leave_team_button}
        >
          Leave team <AngleRight />
        </button>
      </SettingCardRow>
    </SettingCard>
  )
}
